import { render, staticRenderFns } from "./TrainingModuleReferences.vue?vue&type=template&id=76b8d6fb&"
import script from "./TrainingModuleReferences.vue?vue&type=script&lang=ts&"
export * from "./TrainingModuleReferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports